<template>
  <div :class="className" :id="id" :style="{ height: height, width: width }" />
</template>

<script>
export default {
  name: "TingliuShijian",
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "200px"
    },
    unit: {
      type: String,
      default: ""
    },
    xy: {
      type: String,
      default: "x"
    },
    barWidth: {
      type: Number,
      default: 11
    },
    colorList: {
      type: Array,
      default() {
        return ["#1d89ff", "#00ccff", "#4ce8cb", "#eecf50", "#d97b81"];
      }
    },
    chartData: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    if (this.chartData) {
      this.initChart();
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  watch: {
    chartData() {
      if (this.chart) {
        this.chart.dispose();
        this.chart = null;
      }
      this.initChart();
    }
  },
  methods: {
    initChart() {
      let series = [];
      for (let i = 0; i < this.chartData.data.length; i++) {
        let temp = {
          name: this.chartData.data[i].legend,
          type: "bar",
          stack: "总量",
          animationDuration: 3000,
          label: {
            normal: {
              show: false,
              position: "insideRight",
              formatter: "{c}%"
            }
          },
          itemStyle: {
            normal: {
              color: this.colorList[i]
            }
          },
          barWidth: this.barWidth,
          data: this.chartData.data[i].valueList
        };
        series.push(temp);
      }
      var x = {
        type: "value",
        axisTick: {
          show: false
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#414f5a",
            type: "dashed"
          }
        },
        axisLabel: {
          textStyle: {
            color: "#fff",
            fontSize: 13
          },
          formatter: value => {
            return value + this.unit;
          }
        }
      };
      var y = {
        type: "category",
        axisTick: {
          show: false
        },
        axisLabel: {
          textStyle: {
            color: "#fff",
            fontSize: 13
          }
        },
        data: this.chartData.nameList
      };
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {
          icon: "rect",
          top: "-1%",
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            fontSize: 14,
            color: "#fff"
          }
        },
        grid: {
          left: "10%",
          right: "14%",
          top: "15%",
          bottom: "4%",
          containLabel: true
        },
        xAxis: this.xy == "x" ? x : y,
        yAxis: this.xy == "x" ? y : x,
        series: series
      };

      this.chart = this.$echarts.init(document.getElementById(this.id));
      this.chart.setOption(option);
    }
  }
};
</script>
<style scoped lang="less">
.chart {
  width: 100% !important;
  height: 100% !important;
}
</style>
